var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"mt-5",attrs:{"elevation":"4","shaped":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"secondary"}},[_c('v-toolbar-title',{attrs:{"align-center":""}},[_vm._v("السواق")])],1),_c('v-card-text',[_c('carForm')],1)],1),_c('v-divider'),_c('v-divider'),_c('v-card',{staticClass:"mt-5"},[_c('carsTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }